export interface BatchReserveReturnWaitingCollectionForwardingCandidateListRequest {
  dateFrom: string | null
  dateTo: string | null
  holdingBranchCode: string
  outputCondition: string
  batchType: string
  assignOrder: string
  customAssignOrder: string
}

export function BatchReserveReturnWaitingCollectionForwardingCandidateListRequestToJSON(
  value: BatchReserveReturnWaitingCollectionForwardingCandidateListRequest
): any {
  return {
    date_from: value.dateFrom,
    date_to: value.dateTo,
    holding_branch_code: value.holdingBranchCode,
    output_condition: value.outputCondition,
    batch_type: value.batchType,
    assign_order: value.assignOrder,
    custom_assign_order: value.customAssignOrder
  }
}
